import { render, staticRenderFns } from "./Addition.vue?vue&type=template&id=59b94dc9&"
import script from "./Addition.vue?vue&type=script&lang=ts&"
export * from "./Addition.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports